import { connect } from 'react-redux';
import PasswordResetView from './index'
import {passwordUpdate} from '../../actions/Users'

const mapStateToProps = (state, props) => {
  
    return {
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
 
    return {
	passwordUpdate: (data) => {
	    return dispatch(passwordUpdate(data))
	}
    }
}

const PasswordResetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PasswordResetView);




export default PasswordResetContainer;



// WEBPACK FOOTER //
// ./src/components/PasswordUpdate/Container.js